import React from "react";
import ZomatoToBlinkitMigrationUpload from "../../../components/DriverServiceMigration/ZomatoToBlinkitMigration";

const ZomatoToBlinkitMigration = (props) => {
  return <ZomatoToBlinkitMigrationUpload />;
};

export default ZomatoToBlinkitMigration;
